import React, { Component } from "react";
import Form from "../components/Form";
import Divider from "@material-ui/core/Divider";

export default class Sidebar extends Component {
  render() {
    return (
      <aside className="sidebar col-xs-12 col-sm-6 col-lg-4">
        <h3 className="sidebar-title">Contact Us Today</h3>
        <Divider />
        <Form />
      </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./src/includes/Sidebar.js